import { IResourceComponentsProps } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
// import { useForm as } from "@refinedev/react-hook-form";

import React from "react";
import { FormProvider } from "react-hook-form";
import { useLocation } from "react-router-dom";
import "../receipt/form.css";
import { ReiceptsForm } from "./components/Form";

export const ReceiptCreate: React.FC<IResourceComponentsProps> = () => {
  const data = useLocation() as any;

  const form = useForm({
    defaultValues: {
      day: new Date(),
      receipts: Array.from(
        { length: Number(data?.state?.receipts_number) || 1 },
        (_, index) => ({
          receipt_number: null,
          amount_received: null,
          amount_given: 0,
          client_id: null,
          containers: [],
          needs_review: false,
          review_reasons: [],
        })
      ),
    },
  });

  return (
    <Create
      isLoading={form?.refineCore?.formLoading}
      saveButtonProps={form.saveButtonProps}
    >
      <FormProvider {...form}>
        <ReiceptsForm />
      </FormProvider>
    </Create>
  );
};
